import { API_URL } from "../../../../URL";
import {SET_DESCRIPTION} from "../../../constants";

export const PostDescriptionAPI = (body) => {
    return async (dispatch) => {
        const response = await fetch(API_URL + "/post/description/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                card_id: body.card_id,
                html: body.html,
                images: body.images,
                is_edit: body.is_edit
            }),
        });

        const data = await response.json();
        
        dispatch({
            type: SET_DESCRIPTION,
            payload: {
                card_id: body.card_id,
                description: {
                    id: data.description_id,
                    text: data.html
                }
            }
        });

        return data;
    };
};